<template>
  <v-row>
    <v-col class="py-0">
      <v-card>
        <v-card-title>MRA Simulator</v-card-title>
        <v-form class="pa-5">
          <v-row>
            <v-col cols="6">
              <v-text-field
                id="input-1"
                v-model="members"
                type="number"
                :rules="[v => !!v || 'Field is required']"
                required
                @change="formatNumber(members, 'members')"
                placeholder="Number of Members"
                outlined
              ></v-text-field>

              <v-select
                id="input-3"
                label="State:"
                v-model="selected"
                :items="states"
                :rules="[v => !!v || 'Field is required']"
                required
                outlined
                @change="fillCounties()"
              ></v-select>

              <v-select
                label="County:"
                id="input-3"
                v-model="selectedCounty"
                :items="counties"
                :rules="[v => !!v || 'Field is required']"
                required
                outlined
                @change="fillRates()"
              ></v-select>

              <v-text-field
                label="Current MRA"
                id="input-2"
                type="number"
                v-model="mra"
                @change="formatNumber(mra, 'MRA') && calculateRev()"
                required
                :rules="[
                v => !!v || 'Field is required' ,
                v => (parseFloat(v) <= 3) || 'Cannot be greater than 3']"
                placeholder="0"
                outlined
              ></v-text-field>

              <v-text-field
                label="New MRA:"
                id="input-2"
                type="number"
                v-model="newMRA"
                @change="formatNumber(newMRA, 'newMRA') && calculateNewRev()"
                :rules="[
                v => !!v || 'Field is required' ,
                v => (parseFloat(v) <= 3) || 'Cannot be greater than 3']"
                required
                placeholder="0"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="6">

              <div class="subtitle-1 mb-8 ml-8">
                Rate: <span class="font-weight-light">{{formatRevenue(selectedRate)}}</span>
              </div>

              <div class="subtitle-1 ma-8">
                Current Revenue/Member: <span v-if="revenue !== ''" class="font-weight-light">${{formatRevenue(revenue)}}</span>
              </div>

              <div class="subtitle-1 ma-8">
                Total Revenue/Panel: <span v-if="totalRev !== ''" class="font-weight-light">${{formatRevenue(totalRev)}}</span>
              </div>

               <div class="subtitle-1 ma-8">
                New Revenue/Member: <span v-if="newRev !== ''" class="font-weight-light">${{formatRevenue(newRev)}}</span>
              </div>

              <div class="subtitle-1 ma-8">
                Revenue Increase/Decrease: <span v-if="change !== ''" class="font-weight-light">${{formatRevenue(change)}}</span>
              </div>

              <div class="subtitle-1 ma-8">
                Total New Revenue/Panel: <span v-if="totalNewRev !== ''" class="font-weight-light">${{formatRevenue(totalNewRev)}}</span>
              </div>

              <div class="subtitle-1 ma-8">
                Total Adjusted Revenue: <span v-if="adjRev !== ''" class="font-weight-light">${{formatRevenue(adjRev)}}</span>
              </div>

            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import json from '../../assets/simData/data.json';

export default {
  name: 'Simulator',
  data() {
    return {
      data: json,
      states: [],
      members: '',
      rate: [],
      selectedRate: '',
      mra: '',
      revenue: '',
      newMRA: '',
      newRev: '',
      change: '',
      totalRev: '',
      totalNewRev: '',
      adjRev: '',
      counties: [],
      selectedCounty: '',
      selected: '',
      positiveChange: false,
      negativeChange: false,
    };
  },
  watch: {
    selectedCounty() {
      this.calculateRev()
      this.calculateNewRev()
    },
    members() {
      this.calculateRev()
      this.calculateNewRev()
    }
  },
  methods: {
    fillStates() {
      const info = this.data.States;
      Object.keys(info).forEach((key) => {
        this.states.push(key);
      });
    },
    fillCounties() {
      if (this.selected != '') {
        this.counties = [];
        const data = JSON.parse(JSON.stringify(this.data));
        const state = this.selected;
        const states = data.States;
        const current = states[state];

        current.forEach((county) => {
          this.counties.push(county.County);
        });
      }
    },
    fillRates() {
      if (this.selectedCounty != '') {
        const data = JSON.parse(JSON.stringify(this.data));
        const state = this.selected;
        const states = JSON.parse(JSON.stringify(data.States));
        const current = this.selectedCounty;
        if (state in states) {
          const counties = states[state];
          counties.forEach((county) => {
            if (current === county.County) {
              this.selectedRate = county.Rate;
              this.revenue = (this.mra * this.selectedRate).toFixed(2);
            }
          });
        }
      }
    },
    calculateRev() {
      this.revenue = (this.mra * this.selectedRate).toFixed(2);
      if (this.revenue) {
        this.totalRev = (this.revenue * this.members).toFixed(2);
      }
    },
    calculateNewRev() {
      this.newRev = (this.newMRA * this.selectedRate).toFixed(2);
      if (this.newRev) {
        this.totalNewRev = (this.newRev * this.members).toFixed(2);
        this.change = (this.newRev - this.revenue).toFixed(2);
        this.adjRev = (this.totalNewRev - this.totalRev).toFixed(2);

        if (this.change > 0) {
          this.positiveChange = true;
          this.negativeChange = false;
        } else {
          this.positiveChange = false;
          this.negativeChange = true;
        }
      }
    },
    formatNumber(number, id) {
     number = parseFloat(number)
     if(id === 'members') {
       return this.members = number.toFixed(0)
     }
     else if(id === 'MRA') { 
      return this.mra = number.toFixed(2)
     }
     else if(id === 'newMRA'){
       return this.newMRA = number.toFixed(2)
      }
    },
    formatRevenue(num) {
      if (num === undefined) {
        return 'No Data'
      } else {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      }
    },
  },
  created() {
    this.fillStates();
  },
};
</script>
